import * as types from '../types';

function group(state = {
  isFetching: false,
  hasFetched: false,
  name: '',
  seats: 0,
  validUntil: null,
  token: '',
  users: [],
}, action) {
  switch (action.type) {
  case types.GROUP_SUCCESS:
    return { ...state,
        hasFetched: true,
        ...action.response,
      };

  case types.GROUP_FAILURE:
    return { ...state,
        hasFetched: false,
      };
  case types.GROUP_UPDATE_SUCCESS:
    return { ...state,
        hasFetched: true,
        ...action.response,
      };

  case types.GROUP_UPDATE_FAILURE:
    return { ...state,
        hasFetched: false,
      };

  case types.GROUP_TOKEN_REFRESH_SUCCESS:
    return { ...state,
        hasFetched: true,
        token: action.response.token,
      };

  case types.GROUP_TOKEN_REFRESH_FAILURE:
    return { ...state,
        isFetching: false,
        hasFetched: false,
      };

  case types.GROUP_USERS_SUCCESS:
    return { ...state,
        hasFetched: true,
        users: action.response,
      };

  case types.GROUP_USERS_FAILURE:
    return { ...state,
        isFetching: false,
        hasFetched: false,
      };

  case types.GROUP_USER_UPDATE_SUCCESS:
    {
      const newUsers = [...state.users];
      newUsers.forEach((item, i, array) => { if (item.id === action.response.id) array[i] = action.response; }); // eslint-disable-line no-param-reassign

      return { ...state,
          isFetching: false,
          hasFetched: true,
          users: newUsers,
        };
    }
  case types.GROUP_USER_UPDATE_FAILURE:
    return { ...state,
        isFetching: false,
        hasFetched: false,
      };

  case types.GROUP_USER_REMOVE_SUCCESS:

    return { ...state,
        isFetching: false,
        hasFetched: true,
        users: action.response,
      };

  case types.GROUP_USER_REMOVE_FAILURE:
    return { ...state,
        isFetching: false,
        hasFetched: false,
      };

  case types.GROUP_SEND_INVITATION_SUCCESS:
    return { ...state,
        isFetching: false,
        hasFetched: true,
      };

  case types.GROUP_SEND_INVITATION_FAILURE:
    return { ...state,
        isFetching: false,
        hasFetched: false,
      };
  default:
    return state;
  }
}

export default group;



// WEBPACK FOOTER //
// ./src/reducers/group.js